// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/interception-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/interception-procedures/intercepted-pilot-actions.js';
import g1 from '../lessons/air-law/interception-procedures/interception-procedures.js';

mount([g0, g1]);
